import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  level: string;
  messages: string[] = [];
  onMessageChange: () => void;

  add(message: string) {
    this.messages.push(message);
    if (this.onMessageChange) {
      this.onMessageChange();
    }
  }

  clear() {
    this.messages = [];
    if (this.onMessageChange) {
      this.onMessageChange();
    }
  }

  set(message: string, level = 'info') {
    this.clear();
    this.level = level;
    this.add(message);
  }
}
